<template>
<section>
  <div class="talks">
  <h3 class="content__title content__title--contrast">Rewolucyjne gotowanie, rewolucyjne rozmawianie</h3>
    <div class="content__text">… czyli przepisy na lepszą Polskę i pyszne roślinne dania wg Marty Dymek (Jadłonomia), Michała Piróga, Joanny Erbel, Jakuba Roka i innych.</div>
    <div class="talks__slider
    "></div>
    <div class="talks__wrapper"><SliderVideo /></div>
  </div>
</section>

</template>

<script>
import SliderVideo from "../elements/SliderVideo";
export default {
    

  name: "Talks",
  data() {
    return {
      title: "Talks",
    };
  },
  components: {
SliderVideo
  },
   
};
</script>
